export { UberEatsLogo } from './uber-eats-logo';
export type { UberEatsLogoProps } from './uber-eats-logo';
